import React from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts'
import { DailyTraffic } from '../types/stats'
import { Datapoint } from '../service/stats_reader'

interface TrafficChartProps {
  data: DailyTraffic[]
  rawData: Datapoint[]
}

const TrafficChart: React.FC<TrafficChartProps> = ({ data, rawData }) => {
  return (
    <div className="bg-white rounded-lg shadow-[0px_5px_12px_rgba(0,0,0,0.1)] p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        <h2 className="font-ibm-plex-sans font-bold text-xl text-black mb-4 md:mb-0">
          Odtworzenia ({data.length})
        </h2>
      </div>

      <div className="h-[300px] md:h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{ top: 5, right: 20, left: 0, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e5e5" />
            <XAxis
              dataKey="displayDate"
              tick={{ fontSize: 12 }}
              tickMargin={10}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis
              tick={{ fontSize: 12 }}
              tickMargin={10}
              allowDecimals={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e5e5e5',
                borderRadius: '8px'
              }}
              formatter={(value) => [value, 'Odtworzenia']}
            />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#000000"
              strokeWidth={2}
              dot={{ fill: '#000000', strokeWidth: 2, r: 4 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default TrafficChart
